import { WAR_PHASE_DURATIONS } from './constants.js';
/** Every decision deadline and advertised phase duration uses the same rule. */
export function phaseDurationSeconds(config, phase) {
    if (phase === 'RESOLUTION' || config.training)
        return 0;
    return config.phaseSeconds ?? WAR_PHASE_DURATIONS[phase];
}
//# sourceMappingURL=timing.js.map